import { render } from "./PageSections.vue?vue&type=template&id=034f207a&scoped=true"
import script from "./PageSections.vue?vue&type=script&lang=js"
export * from "./PageSections.vue?vue&type=script&lang=js"

import "./PageSections.vue?vue&type=style&index=0&id=034f207a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034f207a"]])

export default __exports__